import React from 'react';

import { useForm, FormProvider } from 'react-hook-form';
import { observer } from 'mobx-react';

import { FaqForm } from '../../../../../components/form-sections/FaqForm/FaqForm';
import { WidgetHeaderActions } from '../components/WidgetHeaderActions/WidgetHeaderActions';
import { useChallengeFormMode } from '../hook/useChallengeFormMode';
import { ChallengeFaqFormValues } from '../../../../../interfaces/ChallengeFormValues';
import { loggedInUserDataStore } from '../../../../../../shared/stores/loggedInUserDataStore';
import { getFaqFormValue, transformFaqsToFormValues } from './utils/getFaqFormValue';
import { challengeService } from '../../../../../services/challengeService';
import { ChallengeFaqSection } from '../../../../../interfaces/SaveChallengeInfo';
import { challengeProfileStore } from '../../../../../stores/challengeProfileStore';

type FaqWidgetProps = {
  challengeId: number;
};

const FaqWidget = observer(({ challengeId }: FaqWidgetProps) => {
  const { statusFlags, invalidSectionFlags, getChallengeStatusDetails } =
    challengeProfileStore;
  const { isEntity } = loggedInUserDataStore;
  const { mode, setEdit, setView } = useChallengeFormMode('faq');

  const formMethods = useForm<{ faqs: ChallengeFaqFormValues }>({
    defaultValues: async () => getFaqFormValue(challengeId),
  });
  const { handleSubmit, reset } = formMethods;

  const handleSave = handleSubmit(async ({ faqs }) => {
    const updatedFaqs = await challengeService.updateChallengeFaqs(
      challengeId,
      faqs as ChallengeFaqSection,
    );

    reset(transformFaqsToFormValues(updatedFaqs));
    getChallengeStatusDetails(challengeId);
    setView();
  });

  const handleCancel = () => {
    reset();
    setView();
  };

  const headerActions = (
    <WidgetHeaderActions
      mode={mode}
      isInvalid={invalidSectionFlags.FAQ}
      onEdit={setEdit}
      onCancel={handleCancel}
      onSubmit={handleSave}
    />
  );

  const canEdit = isEntity && !statusFlags.FINISHED;

  return (
    <FormProvider {...formMethods}>
      <FaqForm mode={mode} headerActions={canEdit ? headerActions : undefined} />
    </FormProvider>
  );
});

export { FaqWidget };
